// components
import { TPersona, IActor } from '@newo/api/gateway';
import ActorItem from '@/pages/Personas/components/Actors/components/ActorItem';
import NoRecords from '@/components/NoRecords';
// utils
import { openConfirmDeleteModal } from '@/utils/ui.tsx';
import { usePersonaActorsQuery } from '@/services/customer/personas/personas.queries.ts';
import { useDeleteActorMutation } from '@/services/actors/actors.queries.ts';

interface ActorsProps {
    persona?: TPersona;
}

const Actors = ({ persona }: ActorsProps) => {
    const { data: actors = [], refetch } = usePersonaActorsQuery(
        persona?.id ?? ''
    );
    const { mutate: deleteUserActor } = useDeleteActorMutation();

    const handleRefetch = () => {
        refetch();
    };

    const handleDelete = (actor: IActor) => {
        openConfirmDeleteModal({
            title: `Delete ${actor.name} ${actor.integration_idn}/${actor.connector_idn} actor?`,
            children: `Are you sure you want to delete actor?`,
            confirmLabel: 'Delete Actor',
            onConfirm: () => {
                deleteUserActor(
                    { actorId: actor.id },
                    {
                        onSuccess: handleRefetch
                    }
                );
            }
        });
    };

    return (
        <div className="break-all flex flex-col gap-4">
            {!persona?.actors.length && <NoRecords> No Actors found</NoRecords>}
            {actors.map((actor) => (
                <ActorItem
                    actor={actor}
                    canBeDeleted={!persona?.agent}
                    key={actor.id}
                    onDelete={handleDelete}
                />
            ))}
        </div>
    );
};

export default Actors;
